import useI18n from '@/hooks/useI18n'
import CommonModal from './CommonModal'
import { memo, useState } from 'react'
import TipsyButton from '../ui-kit/TipsyButton'
import CommonNoticeModal from './CommonNoticeModal'
import { useRecoilState } from 'recoil'
import { linkAccountModalVisibleState } from '@/store/modal'
import { getPlatform } from '@/utils/platform'

function LinkAccountModal() {
  const [open, setOpen] = useRecoilState(linkAccountModalVisibleState)
  const { t } = useI18n()

  const isPC = getPlatform() === 'web_pc'

  if (isPC) {
    return (
      <CommonNoticeModal
        open={open}
        onClose={() => setOpen(false)}
        title={''}
        description={t(
          "You have two separate accounts for this email created by Sign in with Google and Gmail login. You're currently using one of them."
        )}
        confirmButtonText={t('Got it')}
        onConfirm={() => setOpen(false)}
      />
    )
  }
  return null
}

export default memo(LinkAccountModal)
